// extracted by mini-css-extract-plugin
module.exports = {"fb-like":"App_fb-like__2P_Ks","container":"App_container__1MQN3","minicontainer":"App_minicontainer__UPwvW","letra":"App_letra__6MU8v","image":"App_image__3byI1"};